export class OverrideNetworkClassificationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkClassification",
            "baseName": "networkClassification",
            "type": "NetworkClassification",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideNetworkClassificationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
